export const configureZRTK = (options: {}): void => {
  const {} = options;
};
